import { useUser } from "@/app/context/UserContext";
import DynamicForm from "../DynamicForm/DynamicForm";
import { TypeLayout } from "@/app/constants/enums";
import  ListSourceViewUser from "../Fuente/userView/SourceView";
import ConversationView from "../Conversation/ConversacionView";
const LayoutLeft = () => { 
  const { user, setUser, 
    typeLayout, setTypeLayout,       
  } = useUser();
  return ( 
    <aside  className={`w-full h-full`}> 
         
        {(typeLayout == TypeLayout.Advisor?
            <DynamicForm />
          :typeLayout == TypeLayout.Personal?<ListSourceViewUser/>
          //:typeLayout == TypeLayout.Conversation?<ConversationView />
          :""
           
        )}
        
    </aside> 
  );
};

export default LayoutLeft;